import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Router } from 'react-router-dom';
//import createHistory from 'history/createBrowserHistory'
//import { GlobalHistory } from './history';

import './index.css';
import 'semantic-ui-css/semantic.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import './main_lst3.css';
import './main.css';

import App from './App';
//import registerServiceWorker from './registerServiceWorker';

//export const history = createHistory()

ReactDOM.render(
    <BrowserRouter>
  <App />
    </BrowserRouter>
  , document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js